export default __webpack_public_path__ + "static/media/sunny_dayTime.66631fe9.svg";